import { graphql } from "~/gql";

export const UPDATE_ORGANISATIONAL_UNITS = graphql(/* GraphQL */ `
  mutation updateOrganisationalUnits($input: [UpdateManyOrganisationalUnitsInput!]!) {
    updateOrganisationalUnits(input: $input) {
      id
      externalReference
      name
      order
      gpmDangerThreshold
      gpmWarningThreshold
      parent {
        id
        externalReference
        name
        order
        gpmDangerThreshold
        gpmWarningThreshold
      }
      children {
        id
        externalReference
        name
        order
        gpmDangerThreshold
        gpmWarningThreshold
      }
    }
  }
`);
